<template>
  <div class="popup-wrap">
    <div class="dimmed"/>
    <div class="popup-layer">
      <div class="popup-header">
        <h1>이용약관</h1>
        <button type="button" class="btn-close"><i class="ico-close"/></button>
      </div>
      <div class="popup-content">
        <div class="terms-wrap">
          <p class="terms-txt">멀티캠퍼스 이용 약관("약관")은 멀티캠퍼스 주식회사(이하 "멀티캠퍼스"라 합니다)가 운영하는 멀티캠퍼스 대표사이트(www.multicampus.com)에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 합니다)를 이용함에 있어 멀티캠퍼스와 사용자 간의 법적 관계를 관할하고 규정하는 조항이 자세히 설명되어 있습니다.<br>사용자는 약관을 자세히 읽은 후 약관에 동의하지 않을 경우 약관에 동의하거나 서비스에 등록 또는 액세스하거나 이를 이용(이하 "이용"이라 합니다)하지 말아야 합니다. 멀티캠퍼스는 약관의 개별 사본을 보관하지 않으므로 사용자가 필요할 경우 약관의 사본을 저장해두는 것이 좋습니다.<br>사용자가 (a) 민법상 미성년자이거나 (b) 대한민국 법률에 따라 서비스를 받을 수 없도록 금지된 사람인 경우에는 일부 서비스 이용이 제한될 수 있습니다.</p>
          <div class="terms-box">
            <strong>[약관 동의 방법]</strong>
            <p>멀티캠퍼스의 약관 변경 방법 및 멀티캠퍼스 또는 사용자의 약관 해지 방법</p>
          </div>
          <h3 class="terms-tit">1. 약관 동의</h3>
          <p class="terms-txt">1.1. 사용자가 서비스 이용 허가를 받으려면 약관에 동의해야 합니다. 일반적으로 약관에 대하여 사용자는 멀티캠퍼스가 제공하는 사이트에 구현된 "동의" 버튼을 클릭하시거나, 이와 유사하게 구현된 기능을 활용하여 동의할 수 있습니다.<br><br>1.2. 사용자가 서비스를 이용하면 약관에 동의하는 것으로 봅니다. 이 경우 사용자는 서비스 이용과 동시에 약관이 적용되며 멀티캠퍼스가 약관에 따라 사용자로 대우한다는 사실을 인지합니다.</p>
          <h3 class="terms-tit">2. 이용 약관 변경</h3>
          <p class="terms-txt">2.1. 멀티캠퍼스는 필요할 경우 약관을 수정하거나 변경할 수 있습니다. 약관이 변경되는 경우 삼성SDS는 약관의 변경 내용 및 사유를 시행 10일 전(사용자에게 불리하거나 중대한 사항의 변경은 30일 전)에 공지하고, 필요할 경우 이메일 발송 등 적절한 방법으로 통지합니다. 만약, 사용자가 연락처를 기재하지 않거나, 변경 등으로 인하여 개별 통지가 어려운 경우에는 멀티캠퍼스 대표사이트에 변경 약관을 공지함으로써 개별 통지한 것으로 봅니다.<br><br>2.2. 사용자가 변경된 약관의 효력 발생일까지 약관 변경에 대한 거부의사를 명시적으로 표시하지 않거나 약관 변경 이후에 서비스를 이용할 경우 변경된 약관에 동의한 것으로 봅니다. 사용자가 변경된 약관에 동의하지 않는 경우, 멀티캠퍼스 대표사이트가 제공하는 서비스 이용이 제한되거나 정지될 수 있습니다.</p>
          <h3 class="terms-tit">3. 이용 약관 해지 및 해지의 결과</h3>
          <p class="terms-txt">3.1. 약관은 사용자나 멀티캠퍼스가 서비스 이용을 해지하기 전까지 계속하여 효력을 갖습니다.<br><br>3.2. 멀티캠퍼스는 등록 데이터의 일부로 멀티캠퍼스에 제공된 이메일 주소를 사용하거나 해지 통지를 받을 수 있는 기타 적절한 방식을 통해 30일 이전에 해지에 관한 서면 통지를 제공하여 언제든지 서비스 이용을 중단하거나 폐지할 수 있습니다.<br><br>3.3. 다음과 같은 경우 멀티캠퍼스는 언제든지 즉시 본 계약을 해지할 수 있습니다.<br>a. 사용자가 약관을 중대하게 위반한 경우<br>b. 사용자가 약관을 준수할 의도가 없음을 직접, 행동, 진술 또는 기타 방식으로 명백히 표시한 경우<br>c. 멀티캠퍼스에게 서비스를 제공하거나 멀티캠퍼스과 함께 서비스를 제공하는 멀티캠퍼스의 공급자 또는 파트너가 서비스 전체 또는 그 일부의 제공을 종료하기로 결정하거나, 멀티캠퍼스의 공급자 또는 파트너가 멀티캠퍼스과의 모든 관계를 해지하기로 결정하는 경우<br>d. 멀티캠퍼스, 멀티캠퍼스에게 서비스를 제공하거나 멀티캠퍼스와 함께 서비스를 제공하는 멀티캠퍼스의 공급자나 파트너가 관련 법률에 따라 서비스나 그 일부의 제공을 종료해야 하는 경우(예를 들어 관련 법률의 변경 또는 법원의 판결이나 판정에 따라 서비스 또는 그 일부가 불법이 되거나 불법으로 간주되는 경우)<br><br>3.4. 약관의 해지는 약관의 유효 기간 중 발생하거나 초래된 사용자 또는 멀티캠퍼스의 권리, 의무 및 책임에 영향을 미치지 않습니다.<br><br>3.5. 사용자는 수정된 약관에 동의하지 않거나, 사용자나 멀티캠퍼스에 의한 해지 등으로 서비스가 종료된 후에는 서비스를 이용할 수 없습니다.</p>
        </div>
      </div>
    </div>
  </div>
  <!-- //container -->
</template>

<script>
export default {
  name: 'WepModal',
  props: {
    title: {
      type: String,
      default: null
    },
    fullModal: {
      type: Boolean,
      default: true
    },
    fullWithHeader: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    mainclass: {
      type: [String, Object],
      default: ''
    },
    containerClass: {
      type: String,
      default: 'popup_inner'
    },
    useDefaultHeader: {
      type: Boolean,
      default: true
    },
    useDefaultFooter: {
      type: Boolean,
      default: true
    },
    contentClass: {
      type: String,
      default: 'popup_content'
    },
    position: {
      type: String,
      default: 'up',
      validator (value) {
        return [
          'up',
          'down',
          'right',
          'left'
        ].indexOf(value) > -1
      }
    },
    isWrapTransparent: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: String,
      default: () => {
        return 'keep'
      },
      validator: (value) => {
        return [
          'clip',
          'keep'
        ].indexOf(value) >= 0
      }
    }
  },
  data () {
    return {
      savedScrollTop: null,
      isActive: this.visible || false
    }
  },
  computed: {
    wrapClass () {
      return {
        ...this.mainclass,
        'popup_full': this.fullModal
      }
    },
    hasHeaderSlot () {
      return this.$slots['header']
    },
    hasFooterSlot () {
      return this.$slots['footer']
    }
  },
  watch: {
    visible (value) {
      this.isActive = value
    },
    isActive () {
      this.handleScroll()
      this.handleIOSFocus()
    }
  },
  created () {
    alert(1)
  },
  mounted () {
    if (this.isActive) this.handleScroll()
  },
  deactivated () {
    this.close()
  },
  beforeDestroy () {
    this.close()
    if (typeof window !== 'undefined') {
      // reset scroll
      document.documentElement.classList.remove('is-clipped')
      const savedScrollTop = !this.savedScrollTop
        ? document.documentElement.scrollTop
        : this.savedScrollTop
      document.body.classList.remove('overflow')
      document.documentElement.scrollTop = savedScrollTop
      document.body.style.top = null
    }
  },
  methods: {
    close () {
      /*
       * visible.sync 값으로 동기화 해주는 경우 화면 이동시 모달 팝업이 자동으로 해제(false) 처리됨
       * <mmp-modal
          :visible.sync="visible"/>
       */
      this.$emit('update:visible', false)
    },
    handleScroll (e) {
      if (typeof window === 'undefined') return

      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }

      if (this.scroll === 'clip') {
        if (this.isActive) {
          document.documentElement.classList.add('is-clipped')
        } else {
          document.documentElement.classList.remove('is-clipped')
        }
        return
      }

      const el = document.scrollingElement || document.documentElement || document.body

      this.savedScrollTop = !this.savedScrollTop
        ? el.scrollTop
        : this.savedScrollTop

      if (this.isActive) {
        document.body.classList.add('overflow')
      } else {
        document.body.classList.remove('overflow')
      }

      if (this.isActive) {
        document.body.style.top = `-${this.savedScrollTop}px`
        return
      }

      el.scrollTop = this.savedScrollTop
      document.body.style.top = null
      this.savedScrollTop = null
    },
    handleIOSFocus () {
      if (!this.$utils.getUserAgent().iOS) {
        return
      }

      if (this.isActive) {
        // focus disable input/textarea
        if (typeof window !== 'undefined') {
          // dom element 내 input/textarea 비활성화
          const roots = document.querySelectorAll('input, textarea')
          for (const child of roots) {
            child.readOnly = true
            child.disabled = true
          }

          // 모달 팝업창 내 input/textarea만 활성화
          if (this.$refs.mmpModal) {
            const children = this.$refs.mmpModal.querySelectorAll('input, textarea')
            for (const child of children) {
              child.readOnly = false
              child.disabled = false
            }
          }
        }
      } else {
        // focus reset input/textarea
        const roots = document.querySelectorAll('input, textarea')
        for (const child of roots) {
          child.readOnly = false
          child.disabled = false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_common/wep-popup/WepModal.vue